import { useDroppable } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import LeadCard from "./LeadCard";
import { useI18n } from "@/i18n/i18n";

const statusStyles = {
  new: "bg-blue-50 border-blue-200",
  introductory_class: "bg-teal-50 border-teal-200",
  introductory_attended: "bg-emerald-50 border-emerald-200",
  introductory_no_show: "bg-rose-50 border-rose-200",
  contacted: "bg-amber-50 border-amber-200",
  interview_meeting: "bg-violet-50 border-violet-200",
  send_info: "bg-indigo-50 border-indigo-200",
  info_ready: "bg-cyan-50 border-cyan-200",
  enrolled: "bg-emerald-50 border-emerald-200",
  archived: "bg-slate-100 border-slate-200",
  later: "bg-sky-50 border-sky-200",
  not_interested: "bg-rose-50 border-rose-200",
  // Archived-tab columns
  active: "bg-emerald-50 border-emerald-200",
  inactive: "bg-slate-100 border-slate-200",
};

const dotStyles = {
  new: "bg-blue-500",
  introductory_class: "bg-teal-500",
  introductory_attended: "bg-emerald-500",
  introductory_no_show: "bg-rose-500",
  contacted: "bg-amber-500",
  interview_meeting: "bg-violet-500",
  send_info: "bg-indigo-500",
  info_ready: "bg-cyan-500",
  enrolled: "bg-emerald-500",
  archived: "bg-slate-500",
  later: "bg-sky-500",
  not_interested: "bg-rose-500",
  active: "bg-emerald-500",
  inactive: "bg-slate-500",
};

export default function LeadKanbanColumn({ status, title, leads, onLeadClick }) {
  const { t } = useI18n();
  const { setNodeRef, isOver } = useDroppable({ id: status });

  return (
    <div
      ref={setNodeRef}
      className={`rounded-xl border ${statusStyles[status]} p-3 flex flex-col h-full min-w-0 min-h-[400px] transition-all ${isOver ? "ring-2 ring-brand-blue/50" : ""}`}
      data-testid={`kanban-col-${status}`}
    >
      <div className="flex items-center gap-2 mb-3 px-1">
        <span className={`h-2 w-2 rounded-full ${dotStyles[status]}`} />
        <h3 className="text-sm font-semibold text-slate-800 flex-1">{title}</h3>
        <span className="text-xs font-medium text-slate-500 bg-white/60 px-2 py-0.5 rounded-full">
          {leads.length}
        </span>
      </div>
      <SortableContext items={leads.map((l) => l.id)} strategy={verticalListSortingStrategy}>
        <div className="space-y-2 flex-1 min-w-0">
          {leads.length === 0 ? (
            <div className="text-xs text-slate-400 italic text-center py-8">
              {t("lead_no_leads_column")}
            </div>
          ) : (
            leads.map((lead) => (
              <LeadCard key={lead.id} lead={lead} onClick={() => onLeadClick(lead.id)} />
            ))
          )}
        </div>
      </SortableContext>
    </div>
  );
}
